/* eslint-disable */
"use strict";

import { KTUtil } from "../../components/util";

var KTLayoutBrand = function() {
    var _element;

    var _getHeight = function() {
        var height = 0;

        if (_element) {
            height = KTUtil.actualHeight(_element);
        }

        return height;
    }

	return {
		init: function(id) {
            _element = KTUtil.getById(id);

            if (!_element) {
                return;
            }
		},

        getElement: function() {
            return _element;
        },

        getHeight: function() {
            return _getHeight();
        }
	};
}();

if (typeof module !== 'undefined') {
	// module.exports = KTLayoutBrand;
}

export default KTLayoutBrand;